import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Nombrar el ataque",
    opening: localizedGenderNode(
      [
      "Hoy no peleo con el ataque.",
      "Solo noto: esta pasando."
    ],
      [
      "Hoy no peleo con el ataque.",
      "Solo noto: esta pasando."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Como se siente el ataque en mi cuerpo?",
      "Cual es la primera señal de que empieza?",
      "Que temo que pase en ese momento?"
    ],
      [
      "Como se siente el ataque en mi cuerpo?",
      "Cual es la primera señal de que empieza?",
      "Que temo que pase en ese momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Esto es una ola, no un peligro."
    ],
      [
      "Esto es una ola, no un peligro."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion + \"Estoy dentro de una ola\".",
      "una respiracion + \"Estoy dentro de una ola\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "El primer momento",
    opening: localizedGenderNode(
      [
      "Hoy noto el momento en que empieza el ataque.",
      "Solo noto."
    ],
      [
      "Hoy noto el momento en que empieza el ataque.",
      "Solo noto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me siento conmigo un momento.",
      "Una respiracion."
    ],
      [
      "Me siento conmigo un momento.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que paso justo antes?",
      "Donde estaba cuando empezo?",
      "Que hace mi cuerpo primero?"
    ],
      [
      "Que paso justo antes?",
      "Donde estaba cuando empezo?",
      "Que hace mi cuerpo primero?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "En el primer momento tengo un poco de espacio."
    ],
      [
      "En el primer momento tengo un poco de espacio."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion cuando empieza el ataque.",
      "una respiracion cuando empieza el ataque."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Señales del cuerpo",
    opening: localizedGenderNode(
      [
      "Hoy escucho mi cuerpo antes de la historia.",
      "Me quedo conmigo."
    ],
      [
      "Hoy escucho mi cuerpo antes de la historia.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mi respiracion.",
      "Una respiracion."
    ],
      [
      "Noto mi respiracion.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Donde se siente más fuerte el latido?",
      "Que intenta proteger mi cuerpo?",
      "Que podria suavizarse un poco?"
    ],
      [
      "Donde se siente más fuerte el latido?",
      "Que intenta proteger mi cuerpo?",
      "Que podria suavizarse un poco?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Mi cuerpo intenta protegerme."
    ],
      [
      "Mi cuerpo intenta protegerme."
    ]
    ),
    action: localizedGenderNode(
      "una mano en el pecho y una respiracion.",
      "una mano en el pecho y una respiracion."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "La historia del peligro",
    opening: localizedGenderNode(
      [
      "Hoy noto la historia que cuenta peligro.",
      "No la peleo."
    ],
      [
      "Hoy noto la historia que cuenta peligro.",
      "No la peleo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiracion."
    ],
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que escenario aparece primero?",
      "Que es lo más aterrador en eso?",
      "Que posibilidad más suave podria ser cierta?"
    ],
      [
      "Que escenario aparece primero?",
      "Que es lo más aterrador en eso?",
      "Que posibilidad más suave podria ser cierta?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una historia no es un hecho."
    ],
      [
      "Una historia no es un hecho."
    ]
    ),
    action: localizedGenderNode(
      "una frase interna - \"Esto es una historia que aparece\".",
      "una frase interna - \"Esto es una historia que aparece\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "El miedo debajo",
    opening: localizedGenderNode(
      [
      "Hoy toco el miedo debajo del ataque.",
      "Me quedo con el un momento."
    ],
      [
      "Hoy toco el miedo debajo del ataque.",
      "Me quedo con el un momento."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro lento.",
      "Una respiracion."
    ],
      [
      "Respiro lento.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "De que tengo miedo que pase?",
      "Que duele más en ese pensamiento?",
      "Que necesitaba escuchar ahora?"
    ],
      [
      "De que tengo miedo que pase?",
      "Que duele más en ese pensamiento?",
      "Que necesitaba escuchar ahora?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El miedo quiere proteccion, no pelea."
    ],
      [
      "El miedo quiere proteccion, no pelea."
    ]
    ),
    action: localizedGenderNode(
      "nombrar el miedo en silencio.",
      "nombrar el miedo en silencio."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "El ritmo del cuerpo",
    opening: localizedGenderNode(
      [
      "Hoy le doy a mi cuerpo un ritmo más lento.",
      "Solo un momento."
    ],
      [
      "Hoy le doy a mi cuerpo un ritmo más lento.",
      "Solo un momento."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro lento y cuento una respiracion.",
      "Una respiracion."
    ],
      [
      "Respiro lento y cuento una respiracion.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que calma a mi cuerpo aunque sea un poco?",
      "Que me pide mi cuerpo?",
      "Como se que se calma un poco?"
    ],
      [
      "Que calma a mi cuerpo aunque sea un poco?",
      "Que me pide mi cuerpo?",
      "Como se que se calma un poco?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un ritmo lento es un ancla."
    ],
      [
      "Un ritmo lento es un ancla."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion lenta.",
      "una respiracion lenta."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "La necesidad de seguridad",
    opening: localizedGenderNode(
      [
      "Hoy toco la necesidad de seguridad debajo del ataque.",
      "Me quedo conmigo."
    ],
      [
      "Hoy toco la necesidad de seguridad debajo del ataque.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro lento.",
      "Una respiracion."
    ],
      [
      "Respiro lento.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que necesito para sentirme seguro/a?",
      "Que puede ayudar a calmar mi cuerpo?",
      "Que me gustaria darme ahora?"
    ],
      [
      "Que necesito para sentirme seguro/a?",
      "Que puede ayudar a calmar mi cuerpo?",
      "Que me gustaria darme ahora?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un poco de seguridad cambia el tono."
    ],
      [
      "Un poco de seguridad cambia el tono."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra de seguridad.",
      "escribir una palabra de seguridad."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Soltarlo un momento",
    opening: localizedGenderNode(
      [
      "Hoy veo como se siente soltar el ataque por un momento.",
      "Solo un momento."
    ],
      [
      "Hoy veo como se siente soltar el ataque por un momento.",
      "Solo un momento."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Dejo que mi cuerpo se ablande un poco.",
      "Una respiracion."
    ],
      [
      "Dejo que mi cuerpo se ablande un poco.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que pasa en mi cuando lo suelto un momento?",
      "Que me asusta de soltarlo?",
      "Que me calma aunque sea un poco?"
    ],
      [
      "Que pasa en mi cuando lo suelto un momento?",
      "Que me asusta de soltarlo?",
      "Que me calma aunque sea un poco?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Soltarlo un momento tambien es elegir."
    ],
      [
      "Soltarlo un momento tambien es elegir."
    ]
    ),
    action: localizedGenderNode(
      "un momento sin pelear con mi cuerpo.",
      "un momento sin pelear con mi cuerpo."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Un lenguaje interno suave",
    opening: localizedGenderNode(
      [
      "Hoy elijo hablarme con suavidad.",
      "No a la fuerza."
    ],
      [
      "Hoy elijo hablarme con suavidad.",
      "No a la fuerza."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro y noto mi voz interna.",
      "Una respiracion."
    ],
      [
      "Respiro y noto mi voz interna.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Como me hablo durante un ataque?",
      "Como me gustaria escucharlo?",
      "Cual es mi frase suave?"
    ],
      [
      "Como me hablo durante un ataque?",
      "Como me gustaria escucharlo?",
      "Cual es mi frase suave?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una voz suave baja la presion."
    ],
      [
      "Una voz suave baja la presion."
    ]
    ),
    action: localizedGenderNode(
      "decir la frase suave una vez.",
      "decir la frase suave una vez."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Un momento antes de huir",
    opening: localizedGenderNode(
      [
      "Hoy pauso un momento antes de huir.",
      "Solo un momento."
    ],
      [
      "Hoy pauso un momento antes de huir.",
      "Solo un momento."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto el impulso de huir.",
      "Una respiracion."
    ],
      [
      "Noto el impulso de huir.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "De que intento huir?",
      "Que pasa si me quedo un momento?",
      "Que puede sostenerme un momento?"
    ],
      [
      "De que intento huir?",
      "Que pasa si me quedo un momento?",
      "Que puede sostenerme un momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un pequeño momento cambia la direccion."
    ],
      [
      "Un pequeño momento cambia la direccion."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion antes de huir.",
      "una respiracion antes de huir."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Volver al presente",
    opening: localizedGenderNode(
      [
      "Hoy vuelvo a este momento.",
      "Estoy conmigo."
    ],
      [
      "Hoy vuelvo a este momento.",
      "Estoy conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento el peso de mi cuerpo.",
      "Una respiracion."
    ],
      [
      "Siento el peso de mi cuerpo.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que escucho ahora mismo?",
      "Que veo a mi alrededor?",
      "Que siento en este momento?"
    ],
      [
      "Que escucho ahora mismo?",
      "Que veo a mi alrededor?",
      "Que siento en este momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El presente me da suelo."
    ],
      [
      "El presente me da suelo."
    ]
    ),
    action: localizedGenderNode(
      "sentir mis pies un momento.",
      "sentir mis pies un momento."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Un momento antes de comprobar",
    opening: localizedGenderNode(
      [
      "Hoy pauso antes de comprobar si ya paso.",
      "Solo un momento."
    ],
      [
      "Hoy pauso antes de comprobar si ya paso.",
      "Solo un momento."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto el impulso de comprobar.",
      "Una respiracion."
    ],
      [
      "Noto el impulso de comprobar.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que intento asegurar?",
      "Que pasa si no lo se de inmediato?",
      "Que puede ayudarme a esperar un momento?"
    ],
      [
      "Que intento asegurar?",
      "Que pasa si no lo se de inmediato?",
      "Que puede ayudarme a esperar un momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Esperar un momento es fuerza tranquila."
    ],
      [
      "Esperar un momento es fuerza tranquila."
    ]
    ),
    action: localizedGenderNode(
      "pausar antes de comprobar.",
      "pausar antes de comprobar."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Un paso pequeño",
    opening: localizedGenderNode(
      [
      "Hoy elijo un paso pequeño que me calma.",
      "No una revolucion."
    ],
      [
      "Hoy elijo un paso pequeño que me calma.",
      "No una revolucion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro lento y miro alrededor.",
      "Una respiracion."
    ],
      [
      "Respiro lento y miro alrededor.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que paso pequeño puede ayudarme a calmar?",
      "Cuando puedo hacerlo?",
      "Que me ayudara a recordarlo?"
    ],
      [
      "Que paso pequeño puede ayudarme a calmar?",
      "Cuando puedo hacerlo?",
      "Que me ayudara a recordarlo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Lo pequeño basta."
    ],
      [
      "Lo pequeño basta."
    ]
    ),
    action: localizedGenderNode(
      "elegir un paso pequeño.",
      "elegir un paso pequeño."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy termino con una frase que me devuelve a mi.",
      "Elijo presencia."
    ],
      [
      "Hoy termino con una frase que me devuelve a mi.",
      "Elijo presencia."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso un momento antes de responder.",
      "Una respiracion."
    ],
      [
      "Pauso un momento antes de responder.",
      "Una respiracion."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que aprendi de estos ataques?",
      "Cual es la primera señal de que suben?",
      "Cual es mi frase corta?"
    ],
      [
      "Que aprendi de estos ataques?",
      "Cual es la primera señal de que suben?",
      "Cual es mi frase corta?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Elijo un momento antes de responder."
    ],
      [
      "Elijo un momento antes de responder."
    ]
    ),
    action: localizedGenderNode(
      "una respiracion + mi frase.",
      "una respiracion + mi frase."
    ),
  },
].map(buildNormalizedDay);

export const anxietyPanicAttacksBlueprintEs = buildNormalizedPilotBlueprint({
  id: "anxiety_panic_attacks_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "anxiety_panic_attacks",
  category: "anxiety",
  journeyName: {
    he: "התקפי חרדה חוזרים (דופק, קוצר נשימה)",
    en: "Recurrent anxiety attacks (palpitations, shortness of breath)",
    es: "Ataques de ansiedad recurrentes (palpitaciones, dificultad para respirar)",
  },
  days,
});

export default anxietyPanicAttacksBlueprintEs;
